import React, { useState, useRef, useEffect } from 'react';
import {
  IonContent, IonHeader, IonPage, IonTitle, IonToolbar,
  IonItem, IonLabel, IonInput, IonButton, IonIcon,
  IonGrid, IonRow, IonCol, IonCard, IonCardContent,
  IonList, IonThumbnail, IonImg, IonText, IonBadge,
  IonModal, IonButtons, IonSelect, IonSelectOption, 
  IonTextarea, IonAvatar, IonMenuButton, IonCheckbox, IonToast
} from '@ionic/react';
import { 
  cameraOutline, 
  imageOutline, 
  sendOutline, 
  scanOutline, 
  closeCircle,
  personOutline,
  businessOutline,
  calendarOutline,
  server, eyeOutline,
  closeOutline, closeCircleOutline, logOut
} from 'ionicons/icons';
import ServerService from '../../../services/Server';
import './Site.css';
const serverService = new ServerService();

const AccessControl: React.FC = () => {

  const [role, setRole] = useState({
    site_code:''
  });

 
  const [formData, setFormData] = useState({
    id:'',
    cardId: '',
    cardCode: '',
    cardNo: '',
    cardType: '',
    imgProfile : '',
    fullName: '',
    department: '',
    position: '',
    issueDate: '',
    expiryDate: '',
    errorMsg : '',
    messageLogIn: '',
    messageLogOut: ''
  });

  const server = new ServerService();

 
  const [images, setImages] = useState<string[]>([]);
  const [photos, setPhotos] = useState<string[]>([]);
  const [inTime, setInTime] = useState<string>('');
  const cameraInputRef = useRef<HTMLInputElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const scanInputRef = useRef<HTMLIonInputElement>(null);
  const scanInputEscRef = useRef<HTMLIonInputElement>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedPreviewImg, setSelectedPreviewImg] = useState('');

  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedLocationName, setSelectedLocationName] = useState('');
  const [selectedSiteName, setSelectedSiteName] = useState('');
  const [checkKey, setCheckKey] = useState('');
  const [scanStatus, setScanStatus] = useState<'success' | 'error' | ''>('');
  //const [messageIn, setMessageIn] = useState('');
  //const [messageOut, setMessageOut] = useState('');
  const [remark, setRemark] = useState<string>('');
  const [vehicleReg, setVehicleReg] = useState<string>(''); //vehicle_registration
  const [sendButtonText, setSendButtonText] = useState('');
  const [scanEscortCode, setScanEscortCode] = useState('');
  const [accessInName, setAccessInName] = useState('');

  const [validateEscort, setValidateEscort] = useState(false);
  const [requireEscord, setRequireEscord] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastTime, setToastTime] = useState(3000);
  const [permissionHandheld, setPermissionHandheld] = useState(false);
  const [checkedItem, setCheckedItem] = useState(false);
  /*const locations = [
    { code: 'gate_1', name: 'ประตูทางเข้าหน้า' },
    { code: 'gate_2', name: 'ประตูโรงอาหาร' },
    { code: 'warehouse', name: 'คลังสินค้า A' },
    { code: 'office', name: 'ทางเข้าออฟฟิศ' }
  ];*/


  const [locations, setLocations] = useState([{
    code:'',
    name: ''
  }]);

  
  const [checkInData, setCheckInData] = useState<any>({
    timeIn: '',
    photosIn: []
  });

  const openImageModal = (img: string) => {
    setSelectedPreviewImg(img);
    setShowModal(true);
  };

  
  useEffect(() => {
    setTimeout(() => {
      scanInputRef.current?.setFocus();
    }, 500);
  }, []);

 
  const processFiles = (files: FileList | null) => {
    if (!files) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target?.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const MAX_WIDTH = 1000; 
          const scaleSize = MAX_WIDTH / img.width;
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scaleSize;

          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
          
         
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7);
          setImages((prev) => [...prev, compressedBase64]);
        };
      };
    });
  };

  
  const handleRemoveImage = (index: number) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const blurInput = () => {
    setTimeout(async () => {
      const el = await scanInputRef.current?.getInputElement();
      el?.blur();
    }, 1000);
  };
  const handleScan = (code: string) => {
    //(document.activeElement as HTMLElement)?.blur();
   
    setFormData({ ...formData, cardCode: code });
    if (code.length >= 5) {

      getCardDetail(code);

     /* setFormData({
        id : '',
        cardId : '',
        cardCode: code,
        fullName: "นายสมชาย ใจดี",
        department: "ฝ่ายรักษาความปลอดภัย",
        position: "หัวหน้าชุด",
        issueDate: "2023-01-01",
        expiryDate: "2025-12-31"
      }); */
    }


  };

  const handleScanEsc = (code: string) => {
    //setScanEscortCode(code);
    console.log('requireEscord :: ' + requireEscord);
    if(requireEscord){
      checkEscort(code);
    }else{
       setValidateEscort(true);
    }
  };

  const resetForm = () => {
    
    setFormData({
      id : '',
      cardId : '',
      cardCode: '',
      cardNo: '',
      cardType : '',
      imgProfile : '',
      fullName: '',
      department: '',
      position: '',
      issueDate: '',
      expiryDate: '',
      errorMsg : '',
      messageLogIn: '',
      messageLogOut: ''
    });
    setVehicleReg('');
    setRemark('');
    setImages([]);
    setAccessInName('');
    setScanStatus('');
    setScanEscortCode('');
    setRequireEscord(false);
    setCheckedItem(false);
    setValidateEscort(false);
    setCheckInData({
      timeIn: '',
      photosIn: []
    });

    if (cameraInputRef.current) cameraInputRef.current.value = "";
    if (fileInputRef.current) fileInputRef.current.value = "";

   
  scanInputRef.current?.getInputElement().then(el => {
    el.value = ''; 
  });

  
  setTimeout(() => {
    scanInputRef.current?.setFocus();
  }, 100);
   // setTimeout(() => {
   //   scanInputRef.current?.setFocus();
   // }, 100);
   
  /*if (scanInputRef.current) {
    scanInputRef.current.setFocus().then(() => {
     
      scanInputRef.current?.getInputElement().then(el => {
        el.setAttribute('inputmode', 'none');
      });
    });
  }*/
  };

  const handleSubmit = async () => {

    if(!permissionHandheld){
      setShowToast(true);
    }
    
    if(requireEscord && !validateEscort){
       setToastMessage("โปรดสแกน Escort Barcode");
       setShowToast(true);
       return;
    }

   // console.log('selectedLocation :: ' + selectedLocation);
    if(selectedLocation==null || selectedLocation == ''){
     
      setToastMessage("โปรดเลือกจุดตรวจ");
      setShowToast(true);
      return;
    }
    
    const payload = {
      ...formData,
      accessArea : selectedLocation,
      imageCount: images.length,
      remark: remark,
      vehicleReg : vehicleReg,
      photos: images,
      checkedItem : checkedItem,
      scanEscortCode : scanEscortCode 
    };
    var uri = 'checkIn';
    if(formData.id){
       uri = 'checkOut';
    }
    try {
      const response = await fetch(serverService.getPrefixUrl()+'mb/site/'+uri+'?alf_ticket='+serverService.state.ticket, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      console.log('Success:', result);
      resetForm();
    } catch (error) {
      console.error('Error:', error);
    }
    //console.log("Submit Data: ", payload);
    //alert(`บันทึกข้อมูลเรียบร้อย! ส่งรูปภาพทั้งหมด ${images.length} รูป`);
  };

  const getCardDetail = async (cardCode: any) => {
    
    const params = new URLSearchParams({
      cardCode: cardCode,
      locationCode : selectedLocation,
      alf_ticket: serverService.state.ticket
    });
  
    const url = `${serverService.getPrefixUrl()}mb/site/getCardDetail?${params.toString()}`;
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const result = await response.json();
      if(result.success){
        console.log(result.data);
      
        // setFormData(result.data); 
        setFormData({
          id : result.data.access_id,
          cardId : result.data.card_id,
          cardCode: result.data.card_code,
          cardNo: result.data.card_no,
          cardType : result.data.card_type_name,
          imgProfile : result.data.img_profile,
          fullName: result.data.first_name + ' '+ result.data.last_name,
          department: result.data.agency,
          position: result.data.job_position,
          issueDate: result.data.card_issuance_date_text,
          expiryDate: result.data.card_expire_date_text,
          errorMsg : result.data.error_msg,
          messageLogIn: '',
          messageLogOut: ''
        });

        setRequireEscord(result.data.require_escort);
       
        const listPhoto:[] = result.data.photos_list;
        const p:any = [];
        if(listPhoto.length > 0){
          listPhoto.forEach(item => {
            const paramsPhoto = new URLSearchParams({
              nodeRef: item,
              alf_ticket: serverService.state.ticket
            });
            p.push(`${serverService.getPrefixUrl()}mb/site/viewImage?${paramsPhoto.toString()}`);
           // console.log(`${serverService.getPrefixUrl()}mb/site/viewImage?${paramsPhoto.toString()}`);
          });

          setPhotos(p);
           
         /* setCheckInData({
            timeIn: result.data.access_in_time_text,
            photosIn: photos
          }); */
        }

        if(result.data.access_id==''){
          setSendButtonText('ยืนยันเข้าพื้นที่');
        }else{
          setSendButtonText('ยืนยันออกจากพื้นที่');
          setValidateEscort(true);
         // checkEscort(result.data.officer_escort);
        }
        setAccessInName(result.data.access_in_name);
        setInTime(result.data.access_in_time_text);      
        setScanStatus(result.data.scan_status);
        playScanSound(result.data.scan_status);
        setCheckedItem(result.data.check_items);
        setScanEscortCode(result.data.officer_escort);
        
        if(result.data.scan_status=='error'){
          formData.cardCode = '';
          scanInputRef.current?.getInputElement().then(el => {
            el.value = ''; 
          });
        }
        //playScanSound('success');
        /*setTimeout(() => {
          scanInputRef.current?.blur();
        }, 1500);*/
        blurInput();
        
      }else{
        setSendButtonText('');
        setAccessInName('');
        resetForm();
       

        if(result.data.error_msg == 'HANDHELD ACCESS DENINE!'){
          setToastTime(result.hanheldTime);
          setToastMessage(result.hanheldMsg);
          setShowToast(true);
        }else{
          playScanSound('error');
          setScanStatus('error');
          triggerErrorPopup();
        }
        //resetForm();
      }
     

    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {
    setCheckInData({
      timeIn: inTime,
      photosIn: photos
    });
  }, [inTime, photos]);

  useEffect(() => {
    let buffer = ""; 
  
    const handleKeyPress = (e: KeyboardEvent) => {
      console.log(e.key);
      if (e.key === 'Enter') {
        if (buffer.length > 2) { 
          //console.log(buffer);
          //console.log("Scanned Code:", buffer);
          //setCheckKey(buffer); 
          //handleScan(buffer);
          ////getCardDetail(buffer); 
          ////buffer = "";
          //setFormData({ ...formData, cardCode: buffer });          
          
          //scanInputRef.current?.blur();
        }
      } else {
      
        if (e.key.length === 1) {
          buffer += e.key;
        }
      }
    };
  
    
    window.addEventListener('keydown', handleKeyPress);
  
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  /*const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
        //console.log('handleKeyDown');
        //scanInputRef.current?.blur();
    
      
    }
  };*/

  const playScanSound = (type: 'success' | 'error') => {
    const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();
  
    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);
  
    if (type === 'success') {
      // เสียงติ๊ดสั้นๆ สูงๆ (Success)
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(880, audioCtx.currentTime); 
      gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.2);
      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.2);
      
    } else {
      // เสียงตื๊ดต่ำๆ ยาวหน่อย (Error)
      oscillator.type = 'sawtooth';
      oscillator.frequency.setValueAtTime(220, audioCtx.currentTime); 
      gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.5);
      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.5);
      
    }
  };

 
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  
  const triggerErrorPopup = () => {
    setShowErrorPopup(true); 
    
    
    setTimeout(() => {
      setShowErrorPopup(false);
    
      // hiddenInputRef.current?.focus(); 
      setTimeout(() => {
        scanInputRef.current?.setFocus();
      }, 500);
     
    }, 800);
    
  };

  const listLocation = async (siteCode:any) => {
    
    const params = new URLSearchParams({
      type : 'A_LOC_ACCESS',
      flag1 : siteCode,
      alf_ticket: serverService.state.ticket
    });
    const url = `${serverService.getPrefixUrl()}mb/site/listLocation?${params.toString()}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const result = await response.json();
      if(result.success){
        setLocations(result.data);
      }else{

      }
     

    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getPermission = async () => {
    
    const params = new URLSearchParams({
      alf_ticket: serverService.state.ticket
    });
    const url = `${serverService.getPrefixUrl()}mb/site/getPermission?${params.toString()}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const result = await response.json();
      if(result.success){

        if(!result.handheld){
          setToastTime(result.hanheldTime);
          setToastMessage(result.hanheldMsg);
          setShowToast(true);
          setPermissionHandheld(false);
          return;
        }else{
          setPermissionHandheld(true);
        }

        setRole({
          site_code : result.data.site_code
        });

        listLocation(result.data.site_code);

        setSelectedLocation(result.location);
        setSelectedLocationName(result.locationName);
        setSelectedSiteName(result.data.site_name);
      }else{

      }
     

    } catch (error) {
      server.logout();
      window.location.href = "/page/login";
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    getPermission();
  }, []);


  const checkEscort = async (escortCode:any) => {
    const params = new URLSearchParams({
      officerEscort : escortCode,
      alf_ticket: serverService.state.ticket
    });
    const url = `${serverService.getPrefixUrl()}mb/site/checkEscort?${params.toString()}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const result = await response.json();
      if(result.success){
        if(result.escort_allow){
          setScanEscortCode(escortCode);
          setValidateEscort(true);
        }else{
          setScanEscortCode('');
          setToastMessage(result.toast_message);
          setShowToast(true);
          setValidateEscort(false);
        }
      }else{

        setScanEscortCode('');
        setToastMessage(result.toast_message);
        setShowToast(true);
        setValidateEscort(false);
      }

    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleLocationChange = (e: CustomEvent) => {
    const code = e.detail.value;
  
    const selected = locations.find(loc => loc.code === code);
  
    console.log('code:', code);
    console.log('name:', selected?.name);
  
    setSelectedLocation(code);
    setSelectedLocationName(selected?.name);
  };
  
  const BLANK_PROFILE = `data:image/png;base64,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`;
  return (
    <IonPage>
 <IonHeader>

  <IonToolbar style={{"color":"#3880ff"}}>
            <IonButtons slot="start">
              <IonMenuButton />
            {/* <OpenMenuButton /> */ }
            </IonButtons>
              <IonTitle>ตรวจสอบการเข้า-ออกพื้นที่</IonTitle>
            <IonButtons slot="end">
            <IonButton size="large" onClick={e => {
                                server.logout();
                                window.location.href = "/page/login";
              }}><IonIcon icon={logOut}></IonIcon></IonButton>
            </IonButtons>
          </IonToolbar>
  {/*
  <IonToolbar color="dark">
    <IonTitle>ตรวจสอบการเข้า-ออกพื้นที่</IonTitle>
  </IonToolbar>
  */}
  
  {/* 
  <IonToolbar color="light" style={{ '--min-height': '38px' }}>
    <div style={{ display: 'flex', alignItems: 'center', padding: '0 10px', fontSize: '10px' }}>
      <span style={{ color: '#666' }}>จุดตรวจปัจจุบัน:</span>
      <strong style={{ color: 'var(--ion-color-primary)', marginLeft: '4px' }}>
        {selectedLocationName +'('+selectedSiteName+')' || 'ยังไม่ได้ระบุ'}
      </strong>
    </div>
  </IonToolbar>
   */}
  <IonToolbar color="light" style={{ '--min-height': '25px' }}>
  <IonItem>
          <IonLabel style={{ flex: '0 0 80px', fontSize: '12px' }}>
            สถานที่ :
          </IonLabel>

          <IonSelect 
            value={selectedLocation}
            placeholder="เลือกจุดตรวจ"
            onIonChange={handleLocationChange}
            interface="action-sheet"
            style={{
              fontSize: '12px'
            }}
          >
            {locations.map((loc) => (
              <IonSelectOption key={loc.code} value={loc.code}>
                {loc.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>
  </IonToolbar>
</IonHeader>
{/*ion-padding gray-background*/}
      <IonContent className="content-5">
        
      
        <IonCard className="ion-no-margin ion-margin-bottom">
          <IonCardContent>
          <IonItem>
            <IonLabel style={{ flex: '0 0 0 70px' }}>
              Scan
            </IonLabel>

            <IonInput
              ref={scanInputRef}
              value={formData.cardCode}
              placeholder="สแกนผ่านเครื่อง Handheld"
              onIonChange={(e) => handleScan(e.detail.value!)}
            />

            <IonIcon icon={scanOutline} slot="end" color="primary" />
        </IonItem>

           
         {/* 
        <IonItem>
          <IonLabel style={{ flex: '0 0 140px' }}>
            สถานที่ตรวจบัตร
          </IonLabel>

          <IonSelect
            value={selectedLocation}
            placeholder="เลือกจุดตรวจ"
            onIonChange={handleLocationChange}
            interface="action-sheet"
          >
            {locations.map((loc) => (
              <IonSelectOption key={loc.code} value={loc.code}>
                {loc.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>
    */}  
    
    {!selectedLocation && (
      <IonText color="danger" className="ion-padding-start">
        <small>* กรุณาเลือกสถานที่ก่อนบันทึก</small>
      </IonText>
    )}
          </IonCardContent>
        </IonCard>


 

<IonCard className="ion-no-margin"
style={{
  border: scanStatus === 'success' ? '3px solid #2dd36f' : 
          scanStatus === 'error' ? '3px solid #eb445a' : 'none',
  transition: 'border 0.3s ease' // เพิ่มความนุ่มนวลตอนเปลี่ยนสี
}}>
  <IonCardContent>
    <div className="profile-card-content">
      
      {/* ส่วนบน: ข้อมูลบัตร และ รูปภาพโปรไฟล์ */}
      <div className="profile-top-section">
        <IonList lines="none" className="profile-info-list">
          <IonItem>
            <IonLabel>
              <h3>เลขที่บัตร</h3>
              <p><strong>{formData.cardNo || '-'}</strong></p>
            </IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel>
              <h3>ประเภทบัตร</h3>
              <IonText color={formData.cardType ? "danger" : ""}>
                <p><strong>{formData.cardType || '-'}</strong></p>
              </IonText>
            </IonLabel>
          </IonItem>
        </IonList>

        {/* รูปโปรไฟล์แสดงฝั่งขวาของส่วนบน */}
        <img
          className="profile-photo"
          src={
            formData.imgProfile?.trim()
              ? `${serverService.getPrefixUrl()}mb/site/viewImage?nodeRef=${formData.imgProfile}&alf_ticket=${serverService.state.ticket}`
              : BLANK_PROFILE
          }
          onError={(e) => {
            console.log('error img');
            e.currentTarget.src = BLANK_PROFILE;
          }}
          alt="profile"
        />
      </div>

      {/* เส้นคั่นกลาง */}
      <hr className="profile-divider" />

      {/* ส่วนล่าง: ข้อมูลส่วนตัวบุคคล */}
      <IonList lines="full" className="profile-bottom-list">
        <IonItem>
          <IonIcon icon={personOutline} slot="start" />
          <IonLabel>
            <h3>ชื่อ-นามสกุล</h3>
            <p>{formData.fullName || '-'}</p>
          </IonLabel>
        </IonItem>

        <IonItem>
          <IonIcon icon={businessOutline} slot="start" />
          <IonLabel>
            <h3>หน่วยงาน / ตำแหน่ง</h3>
            <p>
              {formData.department
                ? `${formData.department} (${formData.position})`
                : '-'}
            </p>
          </IonLabel>
        </IonItem>

        {/* ส่วนของวันที่คงไว้ด้านล่างสุด */}
        <IonGrid className="ion-no-padding ion-margin-top">
          <IonRow>
            <IonCol size="6">
              <IonItem lines="none">
                <IonLabel>
                  <h3>วันออกบัตร</h3>
                  <p>{formData.issueDate || '-'}</p>
                </IonLabel>
              </IonItem>
            </IonCol>

            <IonCol size="6">
              <IonItem lines="none">
                <IonLabel>
                  <h3>วันหมดอายุ</h3>
                  <IonText color={formData.expiryDate ? "danger" : ""}>
                    <p><strong>{formData.expiryDate || '-'}</strong></p>
                  </IonText>
                </IonLabel>
              </IonItem>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonCheckbox
        checked={checkedItem}
        onIonChange={(e) => setCheckedItem(e.detail.checked)}
        />
        <IonLabel className="ion-padding-start">
        มีของเข้า
        </IonLabel>

        <div hidden={formData.errorMsg==''}>
        <IonItem>
        <IonLabel >
        <p className={
        scanStatus
          ? `msg ${scanStatus === "error" ? "error" : "success"}`
          : "msg"
        }>
          {formData.errorMsg}
        </p>
        </IonLabel>
        </IonItem>
        </div>

        <IonToast
        isOpen={showToast}
        message={toastMessage}
        duration={toastTime}
        position="top"
        color="danger"
        onDidDismiss={() => setShowToast(false)}
        />
        <IonItem>
          
            <IonLabel style={{ flex: '0 0 62px' }}>
              Escort :
            </IonLabel>

            <IonInput
              ref={scanInputEscRef}
              value={scanEscortCode}
              placeholder="สแกน Barcode Escort"
              onIonChange={(e) => handleScanEsc(e.detail.value!)}
            />

            <IonIcon icon={scanOutline} slot="end" color="primary" />
        </IonItem>
        <IonText color="danger">
  
  </IonText>
        {/*
        <IonItem fill="solid" counter={true}>
              <IonLabel position="floating">Scan Escort</IonLabel>
              <IonInput 
                placeholder="สแกน Escort"
              
                ref={scanInputEscRef}
                value={scanEscortCode}
                onIonChange={(e) => handleScanEsc(e.detail.value!)}
               // clearInput={true}
              />
              <IonIcon icon={scanOutline} slot="end" color="primary" />
            </IonItem>
       */}

      </IonList>

    </div>
  </IonCardContent>
</IonCard>
<div style={{ margin: '5px' }} hidden={accessInName==''}>
       <IonLabel>
       <p >
        จุดที่เข้า: <strong>{accessInName}</strong>
      </p>
      </IonLabel>
        </div>    
       


       
        <div className="ion-margin-top">
          <IonText color="medium" className="ion-padding-start">
            <small>แนบหลักฐานรูปภาพ ({images.length})</small>
          </IonText>
          
         
          <input type="file" accept="image/*" capture="environment" hidden ref={cameraInputRef} onChange={(e) => processFiles(e.target.files)} />
          <input type="file" accept="image/*" multiple hidden ref={fileInputRef} onChange={(e) => processFiles(e.target.files)} />

          <IonGrid>
            <IonRow>
              <IonCol size="6">
                <IonButton expand="block" fill="outline" color="secondary" onClick={() => cameraInputRef.current?.click()}>
                  <IonIcon slot="start" icon={cameraOutline} /> ถ่ายรูป
                </IonButton>
              </IonCol>
              <IonCol size="6">
                <IonButton expand="block" fill="outline" color="secondary" onClick={() => fileInputRef.current?.click()}>
                  <IonIcon slot="start" icon={imageOutline} /> เลือกจากเครื่อง
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
          <IonItem>
       
     

        </IonItem>
         
          <div style={{ display: 'flex', overflowX: 'auto', padding: '10px 0' }}>
            {images.map((img, index) => (
              <div key={index} style={{ position: 'relative', minWidth: '100px', marginRight: '10px' }}>
                <IonThumbnail style={{ width: '100px', height: '100px', borderRadius: '8px', overflow: 'hidden' }}>
                  <IonImg src={img} />
                </IonThumbnail>
                <IonIcon 
                  icon={closeCircle} 
                  color="danger" 
                  style={{ position: 'absolute', top: '-5px', right: '-5px', fontSize: '24px', cursor: 'pointer' }}
                  onClick={() => handleRemoveImage(index)}
                />
              </div>
            ))}
          </div>
        </div>

        {formData.id && (
  <IonCard color="light" className="ion-no-margin ion-margin-bottom" style={{ border: '2px dashed #3880ff' }}>
    <IonCardContent>
      <IonText color="primary">
        <p style={{ marginBottom: '10px' }}><strong><IonIcon icon={eyeOutline} /> รูปถ่ายขณะเข้า ({checkInData.photosIn.length} รูป)</strong></p>
      </IonText>
      
     
      <div style={{ display: 'flex', overflowX: 'auto', gap: '10px', paddingBottom: '10px' }}>
        {checkInData.photosIn.map((imgUrl: string, index: number) => (
          <div key={index} style={{ flex: '0 0 auto' }}>
            <IonThumbnail 
              style={{ width: '100px', height: '100px', borderRadius: '8px', overflow: 'hidden', cursor: 'pointer', border: '1px solid #ddd' }}
              onClick={() => openImageModal(imgUrl)}
            >
              <IonImg src={imgUrl} />
            </IonThumbnail>
          </div>
        ))}
      </div>

      <IonItem lines="none" style={{ '--background': 'transparent', marginTop: '5px' }}>
        <IonLabel>
          <p>เวลาที่เข้า: <strong>{inTime} น.</strong></p>
          <p>จุดที่เข้า: <strong>{accessInName}</strong></p>
        </IonLabel>
        <IonBadge color="success" slot="end">อยู่ในพื้นที่</IonBadge>
      </IonItem>
    </IonCardContent>
  </IonCard>
)}
      <IonCard className="ion-no-margin ion-margin-top">
          <IonCardContent>
            <IonItem fill="outline">
              <IonLabel position="stacked">หมายเลขทะเบียนรถ</IonLabel>
              <IonInput  
                value={vehicleReg}
                placeholder="กรอกหมายเลขทะเบียนรถ"
                onIonInput={(e) => setVehicleReg(e.detail.value!)}
              />
            </IonItem>
          </IonCardContent>
        </IonCard>
      <IonCard className="ion-no-margin ion-margin-top">
          <IonCardContent>
            <IonItem fill="outline">
              <IonLabel position="stacked">บันทึกเพิ่มเติม / หมายเหตุ</IonLabel>
              <IonTextarea 
                value={remark}
                placeholder="กรอกรายละเอียด หรือหมายเหตุเพิ่มเติม (ถ้ามี)"
                rows={3}
                onIonInput={(e) => setRemark(e.detail.value!)}
              />
            </IonItem>
          </IonCardContent>
        </IonCard>
       
        <div hidden={!formData.cardCode || !selectedLocation || scanStatus=='error'} className="ion-padding-vertical">
          <IonButton expand="block" color={formData.id !== '' ? 'secondary' : 'success'} size="large" onClick={handleSubmit} disabled={!formData.cardCode || !selectedLocation || scanStatus=='error'}>
            <IonIcon slot="start" icon={sendOutline} 
            style={{
              transform: formData.id !== '' ? 'scaleX(-1)' : 'none'
            }}  
  />
               {sendButtonText}
          </IonButton>
        
        </div>

     
        <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>รูปถ่ายขณะเข้า</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowModal(false)}>
                  <IonIcon icon={closeOutline} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <img src={selectedPreviewImg} alt="Full Preview" style={{ maxWidth: '100%', borderRadius: '12px' }} />
            </div>
          </IonContent>
        </IonModal>

      
        <IonModal 
          isOpen={showErrorPopup} 
          onDidDismiss={() => setShowErrorPopup(false)}
          className="error-popup-modal" 
          backdropDismiss={false}
        >
          <div className="error-popup-content">
            <IonIcon 
              icon={closeCircleOutline} 
              color="danger" 
              className="error-icon"
            />
            <IonText color="danger">
              <h2><strong>ไม่พบข้อมูล!</strong></h2>
            </IonText>
          </div>
        </IonModal>

      </IonContent>
    </IonPage>
  );
};

export default AccessControl;